import { AuthContext } from "@app/providers";
import { getGoogleClassrooms, getCleverClassrooms } from "@app/services";
import React, { useContext, useEffect, useState } from "react";
import { Layout, Icon, Button } from "@app/components";
import { DefaultMessage, EmptyContainer, FormFlexWrapper, FormHeader, FormTitle } from "../commonStyles";
import { ClassroomList } from "@app/modules/classrooms/classroom-components";
import { useLocation } from "@app/utils";
import { StudentDetailWrapper, Value } from "@app/modules/educator/educator-component";
import { Label } from "../input/input-components";
import { ButtonContainer } from "../header/header.component";
import { useHistory } from "react-router-dom";

export default function CleverClassrooms() {
    const { userInfo }: any = useContext(AuthContext);
    const userToken = userInfo && userInfo.sessionToken;
    const [spinner, setSpinner] = useState(false);
    const [classroomsList, setClassroomsList] = useState<any>([]);
    const { navigate } = useLocation();
    let history = useHistory();
    useEffect(() => {
        cleverClassrooms();
    }, []);

    function cleverClassrooms() {
        const params: any = {};
        setSpinner(true)
        Object.assign(params, {
            sessionToken: userToken,
            userId: userInfo && userInfo.userJson.userId,
        });
        getCleverClassrooms(params)
            .then((res) => {
                console.log(res);
                console.log("Test");
                if (res._responseStatus == 1) {
                    setSpinner(false);
                    let classes = res.allClassroomsDocs;
                    setClassroomsList(classes)
                }
                else {
                    setSpinner(false);
                }
            })
    }

    function PortalRedirection() {
        if (userInfo && userInfo.userJson.userType === "educator") {
            navigate('/educator')
        }
    }

    return (

        <Layout>

            <FormHeader className="mb-3">
                <span className="back-icon" onClick={() => PortalRedirection()}>
                    <Icon name="backArrow" />
                </span>
                <FormTitle className="justify-center">
                    <h3 className="primary-header text-center">
                        Sync Clever Classroom
                    </h3>
                </FormTitle>
            </FormHeader>

            <ClassroomList>
                {classroomsList.length === 0 ? '' : <h4 className="secondary-header">Classrooms ({classroomsList && classroomsList.length})</h4>}

                {classroomsList && classroomsList.map((classroom: any, index: number) => {
                    return (
                        <StudentDetailWrapper key={index}>
                               <div className="d-flex justify-space-between align-items-center">
                                    <Label style={{marginBottom:"0px"}}>{classroom.classRoomName}</Label>
                                    <p className="anchor-tag" onClick={() => navigate('/google-students/' + classroom.googleClassroomId)} >Sync</p>
                               </div>
                        </StudentDetailWrapper>

                    )
                })}
            </ClassroomList>
            {spinner &&
                <EmptyContainer>
                    <Icon name="loader" />
                    <DefaultMessage>Loading, please wait...</DefaultMessage>
                </EmptyContainer>
            }
            {classroomsList.length === 0 && spinner === false &&
                <EmptyContainer>
                    <DefaultMessage className="mb-2">No Classrooms found for the user</DefaultMessage>
                </EmptyContainer>
            }

            <><ButtonContainer>
                {/* <Button
                    type="submit"
                    variant="newsecondary"
                    size="large"
                    width="100%"
                    // onClick={() => setShowSuccessPopUp(true)}
                    onClick={() => navigate('/create-classroom')}
                >
                    Submit
                </Button> */}
            </ButtonContainer>
                <Button type="button" variant="bordered" size="large" width={"100%"} onClick={() => history.replace("/classrooms")}>Cancel</Button>
            </>
        </Layout>



    );
}